import { Request } from 'Core/Common/Request';
import { P } from 'Core/Common/Promise';
import {
	IHistoryViewerRequest,
	IHistoryViewerResult,
	IHistoryViewerFieldChangeModel,
	IFilterOptions
} from './Models/HistoryViewerModels';

export class HistoryViewerStore {
	static GetOperations(params: IHistoryViewerRequest, signal?: AbortSignal): P.Promise<IHistoryViewerResult> {
		const deferred = P.defer<IHistoryViewerResult>();
		let request = Request.For('/api/HistoryViewerApi/GetOperations');
		if (signal) {
			request = request.WithAbortSignal(signal);
		}
		request
			.Post(params)
			.done(data => deferred.resolve(data))
			.fail(err => deferred.reject(err));
		return deferred.promise();
	}

	static GetFieldChanges(operationId: string, recordId: number, tableId: number): P.Promise<IHistoryViewerFieldChangeModel[]> {
		const deferred = P.defer<IHistoryViewerFieldChangeModel[]>();
		Request
			.For(`/api/HistoryViewerApi/GetFieldChanges?operationId=${operationId}&recordId=${recordId}&tableId=${tableId}`)
			.Get()
			.done(data => deferred.resolve(data))
			.fail(err => deferred.reject(err));
		return deferred.promise();
	}

	static GetFilterOptions(): P.Promise<IFilterOptions> {
		const deferred = P.defer<IFilterOptions>();
		Request
			.For('/api/HistoryViewerApi/GetFilterOptions')
			.Get()
			.done(data => deferred.resolve(data))
			.fail(err => deferred.reject(err));
		return deferred.promise();
	}

	static GetGeoLocation(ip: string): P.Promise<any> {
		const deferred = P.defer<any>();
		Request
			.For(`/api/HistoryViewerApi/GetGeoLocation?ip=${encodeURIComponent(ip)}`)
			.Get()
			.done(data => deferred.resolve(data))
			.fail(err => deferred.reject(err));
		return deferred.promise();
	}
}
